/**
 * Dizionario de.
 *
 * Tedesco (Fase 2): copre anche l'Austria, che `LOCALE_BY_COUNTRY` suggerisce `de`.
 *
 * Le chiavi devono essere identiche a quelle di `it`: il test
 * `backend/tests/test_jurisdictions.py::test_le_lingue_dichiarate_sono_quelle_tradotte`
 * confronta i file di questa cartella con `APP_LOCALES`, e
 * `test_b2b_frontend_wiring.py` controlla che ogni chiave usata da un pannello
 * esista in **ogni** lingua. Aggiungere una lingua è quindi un file nuovo qui
 * più il codice in `APP_LOCALES`, non una modifica a `i18n.jsx`.
 */
export default {
  "nav": {
    "showcase": "Vitrine",
    "directory": "Unterkünfte",
    "network": "Netzwerk",
    "pricing": "Preise",
    "login": "Anmelden",
    "signup": "Unterkunft registrieren",
    "dashboard": "Dashboard",
    "logout": "Abmelden",
    "book": "Buchen",
    "host_area": "Ich führe eine Unterkunft",
    "find_stay": "Unterkunft finden",
    "bedbank": "Bedbank",
    "claim": "Beanspruchen",
    "affiliates": "Partner",
    "merchant_area": "Gewerbebereich",
    "merchants": "Gewerbe",
    "merchant_login": "Gewerbe-Login",
    "merchant_login_title": "Ich führe ein lokales Geschäft",
    "merchant_space": "Gewerbebereich",
    "host_dashboard": "Gastgeber-Dashboard",
    "account": "Konto",
    "language": "Sprache"
  },
  "landing": {
    "eyebrow": "Plattform für Beherbergungsbetriebe",
    "title1": "Italienische Gastlichkeit,",
    "title2": "in der ganzen Welt.",
    "subtitle": "Machen Sie Ihre Unterkunft bekannt, synchronisieren Sie die OTAs, tauschen Sie Zimmer mit vertrauenswürdigen Partnern. Ein digitales Zuhause für B&Bs, Landhäuser und Hotels.",
    "cta_primary": "Kostenlos starten",
    "cta_secondary": "Vitrinen ansehen",
    "f1_title": "Vitrine in sieben Sprachen",
    "f1_body": "Eine öffentliche Seite auf Italienisch, Englisch, Spanisch, Französisch, Deutsch, Portugiesisch und Griechisch, die Ihre Unterkunft erzählt. Fotos, Zimmer, Direktbuchung mit Stripe.",
    "f2_title": "Netzwerk zwischen Unterkünften",
    "f2_body": "Überbucht? Geben Sie den Gast an einen Partner weiter. Landesweiter Marktplatz + lokale geschlossene Gruppen.",
    "f3_title": "Gruppenanfragen",
    "f3_body": "Veröffentlichen Sie eine Anfrage für eine große Gruppe, nahe Unterkünfte antworten. Zentralisiertes Frühstück inklusive.",
    "f4_title": "Ein Kalender",
    "f4_body": "Direktbuchungen, Zimmer im Netzwerk, OTAs über iCal synchronisiert (kommt bald). Keine Überbuchung.",
    "f5_title": "PMS inklusive",
    "f5_body": "Ein echtes Property Management System in der Plattform: Front Office, Rezeption, Housekeeping, Küche, Einkauf und Betriebsjournal. Keine zusätzliche Software zu bezahlen.",
    "showcase_title": "Unterkünfte in der Vitrine",
    "showcase_sub": "Einige der Häuser, die sich auf Hostaly erzählen.",
    "how_title": "So funktioniert es",
    "how_1": "Registrieren Sie Ihre Unterkunft",
    "how_1b": "Anmeldung in 60 Sekunden. Automatische Prüfung für das MVP.",
    "how_2": "Richten Sie die Vitrine in sieben Sprachen ein",
    "how_2b": "Texte für jede Sprache, Fotos, Services, Zimmer. Veröffentlichen Sie, wenn Sie bereit sind.",
    "how_3": "Treten Sie dem Netzwerk bei",
    "how_3b": "Bieten Sie Last-Minute-Zimmer an, beantworten Sie Gruppenanfragen, erhalten Sie Zahlungen.",
    "final_title": "Das digitale Zuhause der Beherbergungsbetriebe",
    "final_body": "Eine einzige Plattform für Vitrine, Netzwerk und Buchungen."
  },
  "auth": {
    "login": "Anmelden",
    "register": "Unterkunft registrieren",
    "email": "E-Mail",
    "password": "Passwort",
    "structure": "Name der Unterkunft",
    "country": "Land der Unterkunft",
    "country_help": "Es entscheidet, welche Pflichten für Sie gelten. Es ist nicht die Sprache der Oberfläche: die wählen Sie separat.",
    "cin_label": "CIN-Code",
    "cin_help": "Nationaler Identifikationscode (MITUR) — gesetzlich vorgeschrieben (DL 145/2023). Nationales Format: IT + 15 Zeichen (17 insgesamt). Einige Regionen wie Sizilien können längere Formate verwenden (bis 22 Zeichen). Beantragen Sie ihn auf bdsr.ministeroturismo.gov.it",
    "cin_not_required": "Außerhalb Italiens ist der CIN nicht nötig: wir fragen Sie nach Ihrer lokalen Registriernummer, wenn es so weit ist.",
    "submit_login": "Eintreten",
    "submit_register": "Konto erstellen",
    "aff_rules": "Partnerbedingungen",
    "aff_consent": "Ich habe gelesen und akzeptiere:",
    "aff_consent_hint": "Pflicht für die Registrierung der Unterkunft: umfasst Provisionen, Zahlungen, Pflichten der Unterkunft und alle im Vertrag vorgesehenen Aktionen (Klausel 6.4).",
    "switch_to_register": "Kein Konto? Unterkunft registrieren",
    "switch_to_login": "Sie haben schon ein Konto? Anmelden",
    "forgot": "Passwort vergessen?",
    "demo_hint": "Demo: demo@hospitalityhub.it / demo1234",
    "staff_title": "Konto erstellen",
    "staff_hint": "Der Inhaber der Unterkunft hat Ihnen eine Rolle zugewiesen. Verwenden Sie genau die E-Mail-Adresse, mit der er sie vergeben hat: sie verknüpft Ihr Konto mit der Rolle.",
    "staff_name": "Vor- und Nachname",
    "staff_name_help": "Optional. Es hilft nur Ihren Kollegen, Sie zu erkennen.",
    "role_label": "Ihre Rolle in der Unterkunft",
    "role_general_manager": "General Manager (Eigentümer)",
    "role_operations_manager": "Operations Manager",
    "role_manager": "Manager",
    "role_operator": "Mitarbeiter (Reinigung/Küche/Reparaturen)",
    "role_help": "Bestimmt, was Sie im Hotelbetrieb tun können. Der General Manager verwaltet die Rollen des Teams.",
    "staff_password_hint": "Mindestens 8 Zeichen.",
    "staff_submit": "Mein Konto erstellen",
    "account_created": "Konto erstellt",
    "welcome_back": "Willkommen zurück",
    "cin_invalid": "Ungültiger CIN-Code. Er muss mit 'IT' beginnen, gefolgt von 14-20 alphanumerischen Zeichen.",
    "cin_title": "Beginnt mit IT + 14-20 Zeichen (16-22 insgesamt, z. B. Sizilien 18)",
    "aff_required": "Sie müssen die Partnerbedingungen zur Kenntnis nehmen, um fortzufahren.",
    "google": "Weiter mit Google",
    "apple": "Weiter mit Apple",
    "soon": "bald",
    "google_unavailable": "Google-Anmeldung nicht verfügbar",
    "google_not_configured": "Die Google-Anmeldung ist in dieser Installation nicht konfiguriert. Nutzen Sie E-Mail und Passwort; der Schlüssel (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET) muss auf dem Server hinterlegt werden.",
    "apple_failed": "Apple-Anmeldung fehlgeschlagen",
    "contract_docx": "Vollständigen Vertrag herunterladen (DOCX)",
    "costs_title": "Was Hostaly Sie kostet",
    "costs_body": "Keine Anmeldegebühr. Die Provision gilt für jede Buchung und sinkt mit dem Tarif.",
    "to_staff": "Ihnen wurde eine Rolle in einer Unterkunft zugewiesen? Erstellen Sie das Konto hier",
    "host_plans": "Tarife für Gastgeber",
    "pick_plan": "Wählen Sie den passenden Tarif"
  },
  "dash": {
    "welcome": "Willkommen,",
    "overview": "Übersicht",
    "property": "Unterkunft",
    "rooms": "Zimmer",
    "bookings": "Buchungen",
    "marketplace": "Netzwerk",
    "groups": "Gruppenanfragen",
    "reviews": "Bewertungen",
    "ical": "OTA-Sync",
    "swaps": "Tausch",
    "breakfast": "Frühstück",
    "total_bookings": "Buchungen insgesamt",
    "revenue": "Umsatz",
    "open_offers": "Offene Angebote",
    "published": "Veröffentlicht",
    "not_published": "Nicht veröffentlicht",
    "publish": "Vitrine veröffentlichen",
    "unpublish": "Vitrine ausblenden",
    "view_showcase": "Öffentliche Vitrine ansehen",
    "copy_link": "Link kopieren",
    "copied": "Kopiert!",
    "save": "Änderungen speichern",
    "saved": "Gespeichert",
    "name": "Name",
    "city": "Stadt",
    "region": "Region",
    "address": "Adresse",
    "country": "Land",
    "country_help": "Wo das Objekt liegt: von hier kommen die Identifikatoren und Fristen, die wir Ihnen zeigen.",
    "locality": "Gemeinde / Ort",
    "currency": "Währung",
    "currency_help": "Die Währung des Landes. Zimmerpreise und Belastungen bleiben in Euro: die Website rechnet nur für die Anzeige um.",
    "obligations_title": "Pflichten des Landes",
    "obligations_hint": "Was gemeldet werden muss, an wen und bis wann. Die Liste folgt dem Land der Unterkunft: anderes Land, andere Pflichten.",
    "obligations_active": "Aktiv",
    "obligations_toggle": "Als aktiv markieren",
    "obligations_source": "Offizielle Quelle",
    "obligations_verified": "Geprüft am",
    "obligations_error": "Ich kann die Pflicht nicht speichern",
    "timezone": "Zeitzone",
    "phone": "Telefon",
    "desc_it": "Beschreibung (IT)",
    "desc_en": "Beschreibung (EN)",
    "amenities": "Services (durch Komma getrennt)",
    "hero_image": "Hauptfoto",
    "photos": "Fotogalerie",
    "property_type": "Art der Unterkunft",
    "add_room": "Zimmer hinzufügen",
    "room_name": "Zimmername",
    "price_night": "Preis/Nacht (€)",
    "capacity": "Kapazität",
    "photo_url": "Foto-URL",
    "publish_offer": "Ins Netzwerk stellen",
    "no_bookings": "Noch keine Buchung",
    "no_rooms": "Noch keine Zimmer. Fügen Sie eines hinzu, um zu starten.",
    "offer_from": "Von",
    "offer_to": "Bis",
    "post_group_req": "Gruppenanfrage veröffentlichen",
    "title": "Titel",
    "guests": "Gäste",
    "budget": "Budget/Nacht (€)",
    "notes_it": "Notizen (IT)",
    "notes_en": "Notizen (EN)",
    "respond": "Antworten",
    "rooms_offered": "Angebotene Zimmer",
    "message": "Nachricht",
    "send": "Antwort senden",
    "responses": "Antworten",
    "total": "Gesamt",
    "night": "Nacht",
    "nights": "Nächte",
    "upload_photo": "Foto hochladen",
    "uploading": "Wird hochgeladen...",
    "drop_here": "Ziehen oder klicken zum Hochladen",
    "remove": "Entfernen",
    "ical_title": "OTAs per iCal synchronisieren",
    "ical_sub": "Importieren Sie Verfügbarkeiten und Buchungen von Booking, Airbnb, Expedia, Vrbo.",
    "ical_url": "iCal-URL",
    "ical_source": "Plattform",
    "ical_import": "Importieren",
    "ical_last_sync": "Letzter Sync",
    "ical_events": "Importierte Ereignisse",
    "calendar_unified": "Einheitlicher Kalender",
    "swap_forward": "An Partner weiterleiten",
    "swap_title": "Zimmertausch",
    "partner_property": "Partnerunterkunft",
    "partner_room": "Partnerzimmer",
    "commission_10": "10 % Provision werden einbehalten",
    "swap_notes": "Notizen für den Partner",
    "swap_send": "Tausch vorschlagen",
    "no_swaps": "Noch kein Tausch",
    "breakfast_title": "Zentralisiertes Frühstück",
    "breakfast_sub": "Bieten Sie Frühstück für Gäste im Netzwerk an oder buchen Sie es.",
    "add_breakfast_slot": "Neue Frühstückszeit",
    "slot_date": "Datum",
    "slot_time": "Uhrzeit",
    "slot_max": "Max. Plätze",
    "slot_price": "Preis/Platz (€)",
    "book_covers": "Plätze buchen",
    "covers": "Plätze",
    "book_slot": "Buchen",
    "available": "verfügbar",
    "your_breakfast_bookings": "Ihre Frühstücksbuchungen",
    "role": "Rolle",
    "date": "Datum",
    "amount": "Betrag",
    "source": "Herkunft",
    "event_title": "Titel",
    "start": "Beginn",
    "end": "Ende",
    "no_events": "Kein Ereignis — importieren Sie ein iCal oder erhalten Sie eine Buchung.",
    "welcome_back": "Willkommen zurück",
    "toast_uploaded": "Hochgeladen",
    "toast_upload_failed": "Hochladen fehlgeschlagen",
    "toast_error": "Fehler",
    "toast_swap_sent": "Tausch vorgeschlagen · Gast benachrichtigt",
    "toast_slot_added": "Zeit hinzugefügt",
    "toast_slot_booked": "Gebucht",
    "toast_offer_posted": "Angebot veröffentlicht",
    "toast_gr_posted": "Anfrage veröffentlicht",
    "toast_response_sent": "Antwort gesendet",
    "toast_imported": "{n} Ereignisse importiert",
    "select_room": "Zimmer wählen",
    "select_partner": "Partner wählen",
    "select_booking": "Buchung wählen",
    "no_paid_bookings": "Keine bezahlte Buchung",
    "per_cover": "pro Platz",
    "outgoing": "ausgehend",
    "incoming": "eingehend",
    "from_label": "Von:",
    "to_label": "Bis:",
    "commission_10pct": "Provision (10 %)",
    "analytics": "Analytik",
    "revenue_monthly": "Monatsumsatz",
    "direct_bookings": "Direktbuchungen",
    "swap_commissions": "Tauschprovisionen",
    "breakfast_income": "Frühstücksumsatz",
    "no_analytics": "Noch keine Daten — beginnen Sie, Buchungen zu erhalten.",
    "stripe_connect": "Automatische Auszahlungen",
    "connect_start": "Stripe Connect aktivieren",
    "connect_continue": "Onboarding abschließen",
    "connect_done": "Auszahlungen aktiv",
    "connect_pending": "Onboarding läuft",
    "connect_hint": "Erhalten Sie Direktbuchungen automatisch abzüglich der Hostaly-Provision (8 % Base · 6 % Pro · 4,5 % Enterprise). Stripe-Gebühren für die Zahlungsabwicklung trägt das verbundene Konto.",
    "accept_split": "Annehmen und aufteilen",
    "select_partners": "Partner wählen",
    "allocated_rooms": "Zugewiesene Zimmer",
    "allocation_confirmed": "Aufteilung bestätigt",
    "push_title": "Browser-Benachrichtigungen",
    "push_hint": "Erhalten Sie eine Meldung auf Ihrem Gerät, auch wenn der Tab geschlossen ist.",
    "push_enable": "Benachrichtigungen aktivieren",
    "push_disable": "Deaktivieren",
    "push_on": "Aktiv",
    "push_off": "Aus",
    "push_denied": "Vom Browser blockiert",
    "instagram": "Instagram",
    "ig_handle": "Instagram-Konto (@)",
    "ig_posts": "Neueste Beiträge",
    "ig_add": "Beitrag hinzufügen",
    "ig_image": "Bild-URL",
    "ig_caption": "Bildunterschrift",
    "ig_link": "Beitragslink",
    "verification": "Verifizierung",
    "verify_title": "Verifizierung der Unterkunft",
    "verify_hint": "Verifizierte Unterkünfte zeigen das ✓-Abzeichen im Marktplatz und in der Vitrine.",
    "verified": "Verifiziert",
    "pending_verify": "Ausstehend",
    "not_verified": "Nicht verifiziert",
    "submit_verify": "Verifizierung beantragen",
    "vat_number": "USt-IdNr.",
    "business_name": "Firmenname",
    "municipality": "Gemeinde",
    "declaration": "Ich erkläre unter meiner Verantwortung, dass diese Angaben korrekt sind",
    "admin": "Verwaltung",
    "admin_pending": "Offene Anträge",
    "approve": "Genehmigen",
    "reject": "Ablehnen",
    "admin_note": "Interne Notiz",
    "ai_copy": "Mit KI erstellen",
    "ai_copy_title": "Vitrine mit KI erstellen",
    "ai_copy_hint": "Geben Sie einige Stichworte ein — die KI erstellt Beschreibung IT/EN und Services.",
    "ai_keywords": "Stichworte (durch Komma getrennt)",
    "ai_tone": "Ton",
    "ai_generate": "Erstellen",
    "ai_apply": "Auf die Vitrine anwenden",
    "promo_code": "Rabattcode",
    "promo_apply": "Anwenden",
    "promo_valid": "Code gültig",
    "promo_saved": "Sie sparen",
    "trade_nav": "Trade B2B",
    "trade_title": "B2B-Verkauf für Reiseveranstalter und Agenturen",
    "trade_sub": "Kaufen Sie Zimmerkontingente direkt bei italienischen Unterkünften zu reservierten Tarifen.",
    "trade_offers": "Trade-Angebote",
    "trade_login": "Trade-Anmeldung",
    "trade_register": "Agentur registrieren",
    "trade_company": "Name der Agentur / des Reiseveranstalters",
    "trade_vat": "USt-IdNr.",
    "trade_country": "Land",
    "trade_publish": "Trade-Angebot veröffentlichen",
    "trade_new_offer": "Neues Trade-Angebot",
    "trade_rooms_available": "Verfügbare Zimmer",
    "trade_price_per_night": "Preis/Zimmer/Nacht (€)",
    "trade_min_nights": "Mindestnächte",
    "trade_buy": "Jetzt kaufen",
    "trade_orders_mine": "Meine Buchungen",
    "trade_sold": "verkauft",
    "trade_tab": "Trade",
    "partner_center_tab": "Partner Center",
    "channels_tab": "OTA-Kanäle",
    "b2b_title": "B2B-Kanal · Bedbank",
    "b2b_subtitle": "Kaufen Sie Nettotarife bei einer Bedbank, schlagen Sie Ihren Aufschlag auf und geben Sie die Provision an den Partner zurück.",
    "b2b_suppliers": "Lieferanten",
    "b2b_add_supplier": "Lieferant hinzufügen",
    "b2b_mapping": "Hotel-Mapping",
    "b2b_rules": "Preisregeln",
    "b2b_simulator": "Simulator",
    "b2b_settlements": "Abrechnungen",
    "b2b_net": "Nettotarif",
    "b2b_nights": "Nächte",
    "b2b_markup": "Aufschlag",
    "b2b_rebate": "Rückvergütung",
    "b2b_msp": "Mindestpreis (MSP)",
    "b2b_gross": "Publikumspreis",
    "b2b_charged": "Sofort eingenommen",
    "b2b_margin": "Marge",
    "b2b_blocked": "Nicht verkäuflich",
    "b2b_msp_binding": "Preis durch das Lieferantenminimum gebunden",
    "b2b_cashback": "Die Rückvergütung kommt nach der Buchung",
    "b2b_needed_markup": "Nötiger Aufschlag",
    "b2b_target_margin": "Zielmarge",
    "b2b_credentials_missing": "Zugangsdaten fehlen",
    "b2b_confirmed_by": "Bestätigt von",
    "b2b_auto": "Automatisch verknüpft",
    "b2b_review": "Zu bestätigen",
    "b2b_no_candidates": "Kein passender Kandidat",
    "b2b_partners": "Gegenparteien",
    "b2b_add_partner": "Gegenpartei hinzufügen",
    "b2b_partner_kind": "Typ",
    "b2b_partner_agency": "Agentur",
    "b2b_partner_tour_operator": "Reiseveranstalter",
    "b2b_partner_hotel": "Anderes Hotel",
    "b2b_partner_vat": "USt-IdNr.",
    "b2b_payment_terms": "Zahlungsbedingungen",
    "b2b_credit_risk": "Ausfallrisiko",
    "b2b_credit_limit": "Kreditlimit",
    "b2b_terms_agency": "Agenturen und andere Hotels: keine Einnahmen von Verbrauchern, also kein Karten-Checkout.",
    "b2b_outstanding": "Offen",
    "b2b_rates": "Tarife je Gegenpartei",
    "b2b_net_rate": "Nettotarif",
    "b2b_public_price": "Vitrinenpreis",
    "b2b_above_public": "Über dem Vitrinenpreis",
    "b2b_above_public_hint": "Sie verlangen von der Gegenpartei mehr als von einem Gast aus der Vitrine. Die Agentur merkt es und umgeht Sie."
  },
  "vetrina": {
    "book": "Buchen",
    "from": "ab",
    "per_night": "/ Nacht",
    "rooms": "Zimmer",
    "reviews": "Bewertungen",
    "contact": "Kontakt",
    "leave_review": "Bewertung abgeben",
    "guest_name": "Ihr Name",
    "rating": "Bewertung",
    "comment": "Ihr Kommentar",
    "submit": "Bewertung senden",
    "services": "Services",
    "check_in": "Check-in",
    "check_out": "Check-out",
    "guest_email": "Ihre E-Mail",
    "confirm_book": "Bestätigen und zahlen",
    "total_price": "Gesamt",
    "processing": "Verarbeitung...",
    "book_this_room": "Dieses Zimmer buchen",
    "promo_code": "Rabattcode",
    "promo_apply": "Anwenden",
    "promo_valid": "Code gültig",
    "promo_saved": "Sie sparen",
    "traveller_nudge": "Sind Sie Reisende(r)?",
    "prefill_login": "Anmelden, um Ihre Daten vorauszufüllen →",
    "beds": "Betten",
    "beds_hint": "Preis pro Bett: {count} Betten in diesem Schlafsaal verfügbar.",
    "phone": "Telefon",
    "phone_optional": "Telefon (optional)",
    "phone_placeholder": "+49 151 23456789",
    "phone_hint": "Der Gastgeber nutzt sie nur für Rückfragen zu dieser Buchung.",
    "charged_in": "Belastung in {currency} · {amount}",
    "fx_note": "EZB-Kurs: 1 EUR = {rate} {currency} ({date})",
    "fx_stale": "letzter verfügbarer Kurs",
    "pay_now": "Jetzt bezahlen",
    "pay_now_hint": "Karte · sofortige Belastung",
    "pay_at_property": "Vor Ort bezahlen",
    "pay_at_property_hint": "Karte als Garantie · Belastung nur bei No-Show",
    "pay_at_hotel": "Im Hotel bezahlen",
    "pay_at_hotel_hint": "Alles beim Check-in zahlen · Karte als Garantie erforderlich",
    "pay_at_hotel_title": "Alles beim Check-in im Hotel bezahlen",
    "pay_at_hotel_step1": "Jetzt wird nichts belastet: den gesamten Aufenthalt zahlen Sie beim Check-in direkt im Hotel.",
    "pay_at_hotel_step2": "Für die Garantie der Buchung ist eine gültige Kreditkarte erforderlich. Sie wird heute nicht belastet: wir bewahren sie nur als Garantie auf.",
    "pay_at_hotel_step3": "Die Karte wird nur bei No-Show oder verspäteter Stornierung belastet, gemäß den Bedingungen des Hotels.",
    "pay_at_hotel_total": "Vor Ort zu zahlen",
    "pay_at_hotel_continue": "Weiter mit der Karten-Garantie",
    "pay_at_hotel_unavailable": "Die Karten-Garantie ist derzeit nicht verfügbar: buchen Sie mit Kartenzahlung oder kontaktieren Sie das Hotel.",
    "paypal_hint": "Mit Ihrem PayPal-Konto bezahlen",
    "pay_with_paypal": "Mit PayPal bezahlen",
    "paypal_note": "Sie werden zu PayPal weitergeleitet, um die Zahlung sicher abzuschließen, und kommen danach hierher zurück.",
    "redirecting": "Weiterleitung…",
    "enter_email_code": "E-Mail und Code eingeben",
    "invalid_code": "Ungültiger Code",
    "phone_invalid": "Bitte geben Sie eine gültige Telefonnummer ein",
    "name_email_required": "Name und E-Mail erforderlich",
    "pick_dates": "Wählen Sie Ihre Daten",
    "accept_policy": "Sie müssen die No-Show-Regel akzeptieren, um fortzufahren",
    "report_content": "Inhalt melden",
    "guest_terms": "Buchungsbedingungen",
    "free_cancel": "Kostenlose Stornierung",
    "no_show_policy": "No-Show-Regel",
    "penalty": "Gebühr",
    "free_cancel_note": "Kostenlose Stornierung bis {days} Tage vor Check-in.",
    "free_cancel_note_one": "Kostenlose Stornierung bis 1 Tag vor Check-in.",
    "by_date": "Bis {date}.",
    "then_retained": "Danach werden {percent}% einbehalten.",
    "penalty_note": "Stornierung gegen Gebühr: {penalty}.",
    "first_night": "erste Nacht",
    "percent_of_total": "{percent}% des Gesamtpreises",
    "guarantee_card": "Karte als Garantie",
    "no_charge_note": "Jetzt wird nichts belastet. Wir prüfen die Karte nur mit einer temporären 1-€-Verifizierung (sofort freigegeben).",
    "no_show_consent": "Ich akzeptiere, dass bei einem No-Show nach Frist {amount} von der angegebenen Karte abgebucht werden.",
    "confirm_no_charge": "Buchung bestätigen (ohne Belastung)",
    "please_wait": "Bitte warten…",
    "booking_confirmed": "Buchung bestätigt · Karte •••• {last4} als Garantie hinterlegt",
    "verified": "Verifiziert",
    "guest_favourite": "Gästeliebling",
    "guest_favourite_hint": "Gästeliebling — Auszeichnung für die beliebtesten Unterkünfte",
    "rates_loading": "Kurse werden geladen...",
    "per_bed_night": "pro Bett / Nacht",
    "dorm_badge": "Schlafsaal · {beds} Betten ({gender})",
    "floor": "Etage {number}",
    "free_cancel_badge": "Kostenlose Stornierung bis {days} Tage vorher",
    "guest": "Gast",
    "thanks": "Danke!",
    "posting_as": "Sie veröffentlichen als",
    "rating_5": "Perfekt",
    "rating_4": "Gut",
    "rating_3": "Okay",
    "rating_2": "Mangelhaft",
    "rating_1": "Sehr schlecht",
    "dictate_review": "Bewertung diktieren",
    "gender_mixed": "gemischt",
    "gender_female": "Frauen",
    "gender_male": "Männer"
  },
  "guest": {
    "my_bookings": "Meine Buchungen",
    "my_maps": "Meine Karten",
    "travellers_area": "Reisendenbereich",
    "have_account": "Sie haben schon ein Konto?",
    "login": "Anmelden",
    "signup": "Registrieren"
  },
  "pay": {
    "success": "Buchung bestätigt",
    "success_body": "Sie erhalten eine Bestätigungs-E-Mail. Danke!",
    "cancel": "Zahlung abgebrochen",
    "cancel_body": "Es wurde nichts belastet.",
    "back_home": "Zur Startseite",
    "checking": "Zahlung wird geprüft..."
  },
  "common": {
    "close": "Schließen",
    "cancel": "Abbrechen",
    "loading": "Wird geladen...",
    "city": "Stadt",
    "filter_city": "Nach Stadt filtern"
  },
  "trip_group": {
    "propose_title": "Andere Gäste an Ihren Daten",
    "propose_caption": "Es gibt eine Reisendengruppe für {from} → {until}. Sie können dazukommen, auch nur zum Reden: keine Pflicht, gemeinsam zu reisen.",
    "joined_title": "Sie sind in der Gruppe",
    "joined_caption": "Der Gruppenchat ist während der gemeinsamen Daten offen.",
    "join": "Dazukommen",
    "more": "Wie es funktioniert",
    "consent_note": "Mit dem Beitritt aktivieren Sie die Einwilligung zu Reisendengruppen. Sie ist allgemein und widerrufbar: keine Pflicht, gemeinsam zu reisen.",
    "consent_enable": "Teilnahme aktivieren",
    "optin_badge": "Alleinreisende",
    "optin_title": "Allein unterwegs? Andere erleben dasselbe wie Sie.",
    "optin_caption": "An Ihren Daten besuchen, essen und laufen andere genau dort, wo Sie hinwollen: schließen Sie sich der Gruppe an und teilen Sie nur, was Sie möchten.",
    "optin_body": "Die Teilnahme wird erst bei der Reise bestätigt und lässt sich jederzeit zurücknehmen, ohne Folgen für die Buchung.",
    "optin_on": "Teilnahme aktiv",
    "optin_off": "Ich nehme nicht teil",
    "optin_saved": "Einstellung gespeichert. Sie können sie jederzeit ändern.",
    "optin_login": "Als Reisender anmelden, um sie zu aktivieren",
    "optin_error": "Die Einstellung konnte nicht gespeichert werden.",
    "login_required": "Melden Sie sich an, um der Gruppe beizutreten.",
    "join_failed": "Ich kann Sie nicht zur Gruppe hinzufügen.",
    "cap_reached": "Sie sind schon in 2 überlappenden Gruppen: verlassen Sie eine, um dieser beizutreten.",
    "tooltip_title": "Reisendengruppen",
    "tooltip_1": "Gruppiert wird nach Ort und Zeitraum: ein einziger gemeinsamer Aufenthaltstag genügt.",
    "tooltip_2": "Sie können in mehreren Gruppen sein, aber höchstens zwei überlappen sich an denselben Daten.",
    "tooltip_3": "Der Chat ist nur während der gemeinsamen Daten offen: Nachrichten außerhalb dieser Daten kommen nicht an.",
    "tooltip_4": "Andere Mitglieder sehen nur einen kurzen Namen, nie die Details Ihrer Buchung.",
    "tooltip_5": "Wenn Sie die Buchung stornieren, verlassen Sie die Gruppe; bleiben Sie allein, schließt die Gruppe.",
    "tooltip_window": "Zeitraum",
    "loading": "Wird geladen...",
    "back": "Zurück",
    "chat_title": "Gruppenchat",
    "chat_hint": "Nur Mitglieder mit gemeinsamen Daten sehen diese Nachrichten. Es werden keine Buchungsdetails geteilt.",
    "chat_failed": "Ich kann den Chat nicht laden.",
    "send_failed": "Nachricht nicht gesendet.",
    "chat_empty": "Schreiben Sie eine Nachricht.",
    "no_access": "Kein Zugang",
    "no_access_detail": "Der Chat ist Mitgliedern mit einem gemeinsamen Aufenthalt vorbehalten und nur während der geteilten Daten offen.",
    "no_access_after_consent": "Die Einwilligung ist aktiv, aber Sie gehören nicht zu dieser Gruppe: die Daten überschneiden sich nicht mehr, oder die Gruppe ist geschlossen.",
    "not_found": "Gruppe nicht gefunden",
    "no_messages": "Noch keine Nachrichten. Brechen Sie das Eis.",
    "new_message": "Neue Nachricht",
    "message_placeholder": "Schreiben Sie etwas an die Gruppe...",
    "send": "Senden",
    "cancel": "Abbrechen",
    "announce": "Mitteilung",
    "announcement": "Mitteilung",
    "meeting": "Treffen",
    "meeting_proposal": "Treffenvorschlag",
    "new_meeting": "Ein Treffen vorschlagen",
    "meeting_when": "Wann",
    "meeting_when_placeholder": "z. B. Samstagmorgen",
    "meeting_when_required": "Geben Sie an, wann.",
    "meeting_where": "Wo",
    "meeting_where_placeholder": "z. B. Museumseingang",
    "meeting_where_required": "Geben Sie an, wo.",
    "meeting_note": "Notiz (optional)",
    "meeting_note_placeholder": "Etwas hinzuzufügen?",
    "propose": "Vorschlagen",
    "members": "Mitglieder",
    "member_count": "Mitglieder: {n}",
    "no_members": "Noch keine Mitglieder.",
    "anonymous": "Gast",
    "chat_ok": "Im Chat",
    "chat_no": "Nur Gruppe"
  }
};
